export enum DigitalSignatureStatuses {
    AWAITING_SIGNATURE = 0,
    SIGNED = 1,
}
